<div class="privacy-wrapper">
  <div class="header">
    <div class="logo">
      <img src="assets/logo/avs.svg" alt="AVS-Portal Logo" height="35">
    </div>
    <div class="logo-underline"></div>
  </div>
  <div class="privacy-scroll">
    <div class="card shadow rounded-0 privacy-card">
    <h1>Datenschutzerklärung</h1>

    <!-- <p class="privacy-subtitle">
      Eingeloggter Bereich der Plattform avs-connect.de – Anmeldung, Firmen- und Benutzerverwaltung
    </p> -->

    <p>
      Mit dieser Datenschutzerklärung informieren wir Sie über die Verarbeitung personenbezogener Daten bei
      der Nutzung der passwortgeschützten Plattform „AVS Connect“ (avs-connect.de) sowie über Ihre Rechte
      nach der Datenschutz-Grundverordnung (DSGVO).
    </p>

    <h2>1. Verantwortlicher</h2>
    <p>Verantwortlich für die Datenverarbeitung im Sinne von Art. 4 Nr. 7 DSGVO ist:</p>

    <p>
      AVS Verkehrssicherung GmbH<br />
      Marie-Curie-Straße 11<br />
      51377 Leverkusen<br />
      Telefon: +49 2597 9608-24  · E-Mail: opz&#64;avs.eu<br />
      Vertretungsberechtigt: Elena Vasileva, Andreas Schwingeler, Sebastian Minnich, Tobias Schweitzer
    </p>

    <h2>2. Datenschutzbeauftragter</h2>
    <p>Den betrieblichen Datenschutzbeauftragten erreichen Sie unter:</p>

      <p>
        Five Consulting — Dipl.-Ing. Klaus Pampuch<br />
        Frankenforster Str. 44<br />
        51427 Bergisch Gladbach<br />
        Telefon: 02204-7060940  · E-Mail: pampuch&#64;five.consulting <br />
      </p>

    <h2>3. Geltungsbereich</h2>
    <p>
      Diese Erklärung gilt für den passwortgeschützten Bereich der Anwendung AVS Connect, der erst nach
      Anmeldung zugänglich ist. Die Anwendung dient der Verwaltung von Projekten, Geräten und Berichten
      im Bereich der Verkehrssicherung und wird von mehreren Institutionen genutzt; jede Nutzerin und jeder
      Nutzer ist einer Institution und einer Rolle zugeordnet.
    </p>

    <h2>4. Verarbeitete Daten, Zwecke und Rechtsgrundlagen</h2>

    <h3>4.1 Benutzerkonto und Benutzerverwaltung</h3>
    <p>
      Beim Anlegen und Verwalten von Benutzerkonten verarbeiten wir die Stammdaten der Nutzerinnen und
      Nutzer. Eine eigenständige Registrierung ist nicht vorgesehen: Benutzerkonten werden ausschließlich
      durch berechtigte Administratoren angelegt. Die eingeladene Person erhält eine Einladung per E-Mail
      und vergibt ihr Passwort anschließend selbst.
    </p>

    <table>
      <thead>
        <tr>
          <th>Datenkategorien</th>
          <th>Zweck</th>
          <th>Rechtsgrundlage</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Anrede/Titel, Vorname, Nachname, E-Mail-Adresse, zugeordnete Institution,
            Rolle und Berechtigungen, Passwort (verschlüsselt gespeichert)
          </td>
          <td>
            Einrichtung des Zugangs per Einladung, Verwaltung und Pflege des Benutzerkontos;
            Zuweisung von Rollen und Zugriffsrechten
          </td>
          <td>
            Art. 6 Abs. 1 lit. b DSGVO (Durchführung des Nutzungsverhältnisses);
            Art. 6 Abs. 1 lit. f DSGVO (Verwaltung der Zugänge).
            Bei Beschäftigten der Institution ist diese verantwortlich (§ 26 BDSG).
          </td>
        </tr>
      </tbody>
    </table>

    <h3>4.2 Anmeldung und Authentifizierung</h3>
    <p>
      Für die Anmeldung und die Aufrechterhaltung Ihrer Sitzung verarbeiten wir Authentifizierungsdaten.
      Einzelheiten zu den dabei eingesetzten Tokens finden Sie in Abschnitt 5.
    </p>

    <table>
      <thead>
        <tr>
          <th>Datenkategorien</th>
          <th>Zweck</th>
          <th>Rechtsgrundlage</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            E-Mail-Adresse und Passwort, Sitzungs- und Token-Daten (z. B. Session-Identifier,
            Login- und Refresh-Token), Anmeldezeitpunkte
          </td>
          <td>
            Authentifizierung, Zugriffssteuerung, Aufrechterhaltung der angemeldeten Sitzung,
            Schutz vor unbefugtem Zugriff
          </td>
          <td>
            Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. f DSGVO (IT-Sicherheit).
            Speicherung/Auslesen auf dem Endgerät: § 25 Abs. 2 Nr. 2 TTDDG
            (technisch erforderlich).
          </td>
        </tr>
        <tr>
          <td>
            Aktivierungsstatus der Zwei-Faktor-Authentifizierung (2FA),
            geheimer Schlüssel (Secret Key) zur Prüfung der Einmalcodes
          </td>
          <td>
            Zusätzliche Absicherung des Benutzerkontos durch Zwei-Faktor-Authentifizierung per
            Authenticator-App (TOTP-Verfahren); Prüfung der Einmalcodes bei der Anmeldung
          </td>
          <td>
            Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. f DSGVO;
            Sicherheit der Verarbeitung nach Art. 32 DSGVO).
          </td>
        </tr>
      </tbody>
    </table>

    <p>
      <strong>Zwei-Faktor-Authentifizierung (2FA):</strong> Zur zusätzlichen Absicherung Ihres Benutzerkontos
      bieten wir eine Zwei-Faktor-Authentifizierung per Authenticator-App (TOTP-Verfahren) an. Bei Aktivierung
      speichern wir den Aktivierungsstatus sowie den zur Prüfung der Einmalcodes erforderlichen geheimen
      Schlüssel (Secret Key) in Ihrem Benutzerkonto. Weitere Daten, insbesondere zur Identifikation Ihres
      Endgeräts, werden im Rahmen der 2FA nicht verarbeitet. Die Einmalcodes werden lokal in der von Ihnen
      gewählten Authenticator-App auf Ihrem Endgerät erzeugt; eine Übermittlung von Daten an den Anbieter der
      App findet durch uns nicht statt. Der Secret Key wird gelöscht, sobald die 2FA deaktiviert oder das
      Benutzerkonto gelöscht wird.
    </p>

    <h3>4.3 Firmen- und Institutionsverwaltung</h3>
    <p>
      In der Firmenverwaltung werden die Stammdaten der angebundenen Institutionen sowie deren
      Ansprechpartner gepflegt und die zugehörigen Nutzer und Inhalte zugeordnet.
    </p>

    <table>
      <thead>
        <tr>
          <th>Datenkategorien</th>
          <th>Zweck</th>
          <th>Rechtsgrundlage</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Bezeichnung und Anschrift der Institution, Ansprechpartner und deren Kontaktdaten,
            zugeordnete Benutzer, Projekte und Geräte
          </td>
          <td>
            Mandantenverwaltung, Zuordnung von Nutzern, Daten und Berechtigungen zur jeweiligen
            Institution, Abrechnung und Vertragsabwicklung
          </td>
          <td>
            Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. f DSGVO
            (organisierter Plattformbetrieb)
          </td>
        </tr>
      </tbody>
    </table>

    <h3>4.4 Nutzungs- und Protokolldaten</h3>
    <p>
      Beim Betrieb der Plattform fallen technische Protokolldaten an, unter anderem zur Fehleranalyse
      (Error Engine).
    </p>

    <table>
      <thead>
        <tr>
          <th>Datenkategorien</th>
          <th>Zweck</th>
          <th>Rechtsgrundlage</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Funktionen, übertragene Datenmenge,
            Browser- und Geräteinformationen, Fehlerprotokolle
          </td>
          <td>
            Bereitstellung und Stabilität der Anwendung, Fehlererkennung und -behebung,
            Gewährleistung der IT-Sicherheit, Missbrauchsabwehr
          </td>
          <td>
            Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und störungsfreien Betrieb)
          </td>
        </tr>
      </tbody>
    </table>

    <h3>4.5 Inhalts- und Fachdaten (Projekte, Geräte, Berichte)</h3>
    <p>
      Im Rahmen der Nutzung werden fachliche Inhalte zu Projekten, Geräten und Berichten verarbeitet.
      Soweit hierbei personenbezogene Daten Dritter durch eine Institution eingegeben werden, erfolgt dies
      in deren Verantwortung; siehe Abschnitt 6.
    </p>

    <h2>5. Cookies und lokaler Speicher</h2>
    <p>
      Wir setzen ausschließlich technisch erforderliche bzw. funktionale Einträge im Browser ein, die für die
      Anmeldung und die Bedienung der Anwendung notwendig sind. Eine Einwilligung ist nach § 25 Abs. 2 Nr.
      2 TTDDG nicht erforderlich; Dienste zu Analyse- oder Marketingzwecken werden nicht eingesetzt.
    </p>

    <table>
      <thead>
        <tr>
          <th>Typ</th>
          <th>Name</th>
          <th>Zweck</th>
          <th>Speicherdauer</th>
          <th>Kategorie</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Cookie</td>
          <td>refreshToken</td>
          <td>
            Refresh-Token zur Aufrechterhaltung der Anmeldung (api.avs-digital.de)
          </td>
          <td>1 Tag</td>
          <td>technisch erforderlich</td>
        </tr>
        <tr>
          <td>LS</td>
          <td>user_token</td>
          <td>Login-Token / Authentifizierung</td>
          <td>bis Abmeldung</td>
          <td>technisch erforderlich</td>
        </tr>
        <tr>
          <td>LS</td>
          <td>session-id</td>
          <td>Session-Identifier</td>
          <td>bis Abmeldung</td>
          <td>technisch erforderlich</td>
        </tr>
        <tr>
          <td>LS</td>
          <td>role</td>
          <td>Benutzerrolle zur Zugriffssteuerung</td>
          <td>bis Abmeldung</td>
          <td>technisch erforderlich</td>
        </tr>
        <tr>
          <td>LS</td>
          <td>last-tab-closed-at</td>
          <td>Zeitstempel der letzten Tab-Schließung</td>
          <td>bis Überschreibung</td>
          <td>funktional</td>
        </tr>
        <tr>
          <td>LS</td>
          <td>googleMapsConsent</td>
          <td>Falls Einwilligung zur Nutzung von Google maps Diensten erteilt wurde</td>
          <td>bis Abmeldung</td>
          <td>funktional</td>
        </tr>
        <tr>
          <td>SS</td>
          <td>activeRouteStation</td>
          <td>Aktive Routen-Station (Oberflächenzustand)</td>
          <td>Sitzung</td>
          <td>funktional</td>
        </tr>
        <tr>
          <td>SS</td>
          <td>activeDeviceRouteStation</td>
          <td>Aktives Gerät (Oberflächenzustand)</td>
          <td>Sitzung</td>
          <td>funktional</td>
        </tr>
        <tr>
          <td>SS</td>
          <td>activeGroup</td>
          <td>Aktive Gruppe (Oberflächenzustand)</td>
          <td>Sitzung</td>
          <td>funktional</td>
        </tr>
        <tr>
          <td>SS</td>
          <td>activeProject</td>
          <td>Aktives Projekt (Oberflächenzustand)</td>
          <td>Sitzung</td>
          <td>funktional</td>
        </tr>
      </tbody>
    </table>

    <p class="table-note">LS = Local Storage, SS = Session Storage.</p>

    <h2>6. Verantwortlicher und Auftragsverarbeiter</h2>
    <p>
      Für die Benutzer-, Anmelde-, Firmen- und Protokolldaten (Abschnitte 4.1 bis 4.4) sind wir
      Verantwortlicher. Soweit eine Institution über die Plattform personenbezogene Daten verarbeitet, für die
      sie die Zwecke und Mittel bestimmt (insbesondere Inhalts- und Fachdaten nach Abschnitt 4.5), handeln
      wir insoweit als Auftragsverarbeiter nach Art. 28 DSGVO; verantwortlich ist dann die jeweilige Institution.
      Grundlage ist der zwischen uns und der Institution geschlossene Auftragsverarbeitungsvertrag.
      Betroffene wenden sich in diesen Fällen vorrangig an ihre Institution.
    </p>

    <h2>7. Empfänger und Auftragsverarbeiter</h2>
    <p>
      Eine Übermittlung Ihrer Daten findet nur statt, soweit dies zur Erbringung der Leistung erforderlich oder
      gesetzlich vorgesehen ist. Im Rahmen des Betriebs setzen wir sorgfältig ausgewählte Auftragsverarbeiter
      ein, die für uns auf Grundlage von Verträgen nach Art. 28 DSGVO tätig werden:
    </p>

    <ul>
      <li>
        IT-/Hosting-Dienstleister für den Betrieb der Anwendung und der Schnittstelle
        <p>
          maxcluster GmbH Lise-Meitner-Straße 1b 33104 Paderborn

        </p>
        
      </li>
    </ul>

    <p>
      Innerhalb der
      AVS-Unternehmensgruppe können Daten an
      verbundene Unternehmen weitergegeben werden, soweit dies für die genannten Zwecke erforderlich ist.
    </p>

    <h2>8. Übermittlung in Drittländer</h2>    
      <p>Im Interesse der ansprechenden Darstellung der GPS Positionen unserer Geräte bieten wir Kartendarstellungen unter Nutzung von Google maps Diensten an.
        Anbieter dieser Dienste ist die Google Ireland Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland. 
        Bei der Nutzung dieser Dienste werden Ihre Daten, z.B. die IP-Adresse, in der Regel an Server in den USA übertragen. 
        Details über die Verarbeitung dieser Daten durch Google finden Sie in der <a href="https://policies.google.com/privacy"> Datenschutzerklärung von Google</a>.
        Ihre Einwilligung zur Datenübertragung zwecks Nutzung der Google maps Dienste wird nur innerhalb Ihres Browsers bis zur Abmeldung gespeichert. 
        Sie können Ihre Einwilligung jederzeit widerrufen.
        Rechtsgrundlagen für die Verarbeitung sind § 25 Abs. 1 TDDDG und Art. 6 Abs. 1 lit. a DSGVO.
      </p> 
    
    <p>
      Eine darüber hinausgehende Übermittlung personenbezogener Daten in Länder außerhalb der EU/des EWR ist nicht vorgesehen.
      Sollte im Einzelfall ein Drittlandbezug entstehen, erfolgt dieser nur auf Grundlage geeigneter Garantien
      nach Art. 44 ff. DSGVO.
    </p>

    <h2>9. Speicherdauer und Löschung</h2>
    <ul>
      <li>
        Benutzerkonto- und Stammdaten: für die Dauer des Nutzungsverhältnisses; anschließend Löschung,
        soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </li>
      <li>
        Authentifizierungs-/Sitzungsdaten: nur für die Dauer der Sitzung bzw. bis zur Abmeldung.
      </li>
      <li>
        2FA-Daten (Aktivierungsstatus, Secret Key): bis zur Deaktivierung der 2FA bzw. zur Löschung des
        Benutzerkontos.
      </li>
      <li>
        Protokoll- und Fehlerdaten: kurzfristig zu Sicherheits- und Analysezwecken, danach Löschung oder
        Anonymisierung.
      </li>
      <li>
        Daten mit handels- oder steuerrechtlichem Bezug: bis zum Ablauf der gesetzlichen
        Aufbewahrungsfristen (regelmäßig 6 bzw. 10 Jahre).
      </li>
    </ul>

    <h2>10. Ihre Rechte</h2>
    <p>
      Ihnen stehen gegenüber dem Verantwortlichen folgende Rechte hinsichtlich der Sie betreffenden
      personenbezogenen Daten zu:
    </p>

    <ul>
      <li>Auskunft (Art. 15 DSGVO),</li>
      <li>Berichtigung (Art. 16 DSGVO),</li>
      <li>Löschung (Art. 17 DSGVO),</li>
      <li>Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
      <li>Datenübertragbarkeit (Art. 20 DSGVO),</li>
      <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO).</li>
    </ul>

    <p>
      Soweit die Verarbeitung auf einer Einwilligung beruht, können Sie diese jederzeit mit Wirkung für die
      Zukunft widerrufen (Art. 7 Abs. 3 DSGVO). Zur Ausübung Ihrer Rechte genügt eine Mitteilung an den
      Verantwortlichen oder den Datenschutzbeauftragten.
    </p>

    <h2>11. Beschwerderecht bei der Aufsichtsbehörde</h2>
    <p>
      Unbeschadet anderweitiger Rechtsbehelfe haben Sie das Recht auf Beschwerde bei einer
      Aufsichtsbehörde (Art. 77 DSGVO). Zuständige Aufsichtsbehörde für den Verantwortlichen ist:
    </p>

    <p>
      <strong>
        Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)
      </strong>
      <br />
      Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW<br />
      Kavalleriestraße 2–4 <br />
      40213 Düsseldorf<br />
      poststelle&#64;ldi.nrw.de<br />
    </p>

    <h2>12. Erforderlichkeit der Bereitstellung</h2>
    <p>
      Die Bereitstellung der für Anmeldung und Kontoführung erforderlichen Daten ist notwendig, um die
      Plattform nutzen zu können. Ohne diese Daten ist eine Anmeldung und Nutzung des
      passwortgeschützten Bereichs nicht möglich. Die Nutzung der Zwei-Faktor-Authentifizierung ist freiwillig,
      soweit sie nicht durch Ihre Institution oder uns für bestimmte Rollen vorgegeben wird.
    </p>

    <h2>13. Automatisierte Entscheidungsfindung</h2>
    <p>
      Eine ausschließlich automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22
      DSGVO findet nicht statt.
    </p>

    <h2>14. Änderungen dieser Datenschutzerklärung</h2>
    <p>
      Wir passen diese Datenschutzerklärung an, sobald Änderungen der Verarbeitung oder der Rechtslage
      dies erfordern. Es gilt die jeweils in der Anwendung abrufbare Fassung.
    </p>

    <h2>15. Stand</h2>
    <p>Diese Datenschutzerklärung hat den Stand 3. August 2026.</p>

    <button *ngIf="showAcceptButton" class="accept-button" type="button" [disabled]="isLoading" (click)="onAcceptClicked()">
      {{ isLoading ? 'Speichern...' : 'Akzeptieren' }}
    </button>
    </div>
  </div>
  <div>
    <avs-app-footer></avs-app-footer>
  </div>
</div>
